import request from "../utils/request"

export default {
    publishPredict(data) {
        return request({
            url: `/predict?ac=publish`,
            method: 'post',
            data
        })
    },

    getPredictList(params) {
        return request({
            url: `/predict?ac=list`,
            method: 'get',
            params
        })
    },

    /**
     * 功能：读取指定彩种和一级玩法当前存在的子标题筛选项。
     * 参数：params 包含 lotteryId、playId 和可选 articleType。
     */
    getPredictSonTitleOptions(params) {
        return request({
            url: `/predict?ac=sonTitleOptions`,
            method: 'get',
            params
        })
    },

    /**
     * 功能：读取方案排行榜可选的一级方案和子标题Key。
     * 参数：params 包含 lotteryId。
     */
    getPredictRankingOptions(params) {
        return request({
            url: `/predict?ac=rankingOptions`,
            method: 'get',
            params
        })
    },

    /**
     * 功能：分页读取精确方案维度的总分、命中或连红排行榜。
     * 参数：params 包含彩种、方案、子标题Key、榜单类型和分页参数。
     */
    getPredictRankingList(params) {
        return request({
            url: `/predict?ac=rankingList`,
            method: 'get',
            params
        })
    },

    /**
     * 功能：分页读取仅包含认证专家的精确方案维度排行榜。
     * 参数：params 包含彩种、方案、子标题Key、榜单类型和分页参数。
     */
    getPredictExpertRankingList(params) {
        return request({
            url: `/predict?ac=expertRankingList`,
            method: 'get',
            params
        })
    },

    /**
     * 功能：读取单张规律贴卡片，购买后用于原位刷新解锁内容。
     * 参数：params 查询参数，包含规律贴文章ID。
     */
    getPredictRuleCard(params) {
        return request({
            url: `/predict?ac=ruleCard`,
            method: 'get',
            params
        })
    },

    /**
     * 功能：获取当前彩种的推荐作者列表。
     * 参数：params 查询参数，包含 lotteryId、page、pageSize。
     */
    getPredictRecommendAuthors(params) {
        return request({
            url: `/predict?ac=recommendAuthors`,
            method: 'get',
            params
        })
    },

    /**
     * 功能：获取前台全部认证专家列表。
     * 参数：params 查询参数，包含 keyword、page、pageSize。
     */
    getPredictCertifiedExperts(params) {
        return request({
            url: `/predict?ac=certifiedExperts`,
            method: 'get',
            params
        })
    },

    /**
     * 功能：获取精选专区预测文章列表。
     * 参数：params 查询参数，包含 lotteryCode、betRange、page、pageSize。
     */
    getPredictSelectedZone(params) {
        return request({
            url: `/predict?ac=selectedZone`,
            method: 'get',
            params
        })
    },

    getPredictFavoriteArticles(params) {
        return request({
            url: `/predict?ac=list`,
            method: 'get',
            params: {
                ...params,
                feed: 'favorite'
            }
        })
    },

    searchPredictArticles(params) {
        return request({
            url: `/predict?ac=search`,
            method: 'get',
            params
        })
    },

    getPredictDetail(params) {
        return request({
            url: `/predict?ac=detail`,
            method: 'get',
            params
        })
    },

    getPredictRecommendSimilar(params) {
        return request({
            url: `/predict?ac=recommendSimilar`,
            method: 'get',
            params
        })
    },

    getPredictRecommendAuthorOther(params) {
        return request({
            url: `/predict?ac=recommendAuthorOther`,
            method: 'get',
            params
        })
    },

    purchasePredictArticle(data) {
        return request({
            url: `/predict?ac=purchase`,
            method: 'post',
            data
        })
    },

    tipPredictAuthor(data) {
        return request({
            url: `/predict?ac=tip`,
            method: 'post',
            data
        })
    },

    getPredictAuthorHome(params) {
        return request({
            url: `/predict?ac=authorHome`,
            method: 'get',
            params
        })
    },

    getPredictAuthorArticles(params) {
        return request({
            url: `/predict?ac=authorArticles`,
            method: 'get',
            params
        })
    },

    getPredictMyArticles(params) {
        return request({
            url: `/predict?ac=myArticles`,
            method: 'get',
            params
        })
    },

    deletePredictMyArticle(id) {
        return request({
            url: `/predict?ac=deleteMyArticle`,
            method: 'post',
            params: { id }
        })
    }
}
